export const iconFontAwesomeGamingHeadset = (
	<i className="fa-solid fa-headset"></i>
);
